import Typography from '@/components/Typography';
import TextStyles from '@/constants/typography.constants';
import Image from 'next/image';
import styled from 'styled-components';

interface StyledLoginBannerProps {
  $isLoggedIn: boolean;
  $isDesktopPMT: boolean;
}

export const StyledLoginBanner = styled.div<StyledLoginBannerProps>(({ theme, $isLoggedIn, $isDesktopPMT }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing[20],
  backgroundColor: '#fff',
  borderRadius: $isDesktopPMT ? theme.spacing[4] : 0,
  boxShadow: '0px 0.5px 2px 0px #60617029, 0px 0px 1px 0px #28293D14;',
  cursor: $isLoggedIn ? 'default' : 'pointer',
  transition: 'all 0.2s ease',

  ...(!$isLoggedIn && {
    '&:hover': {
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
    },
  }),
}));

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[12],
  height: '100%',
}));

export const TextContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  height: '100%',
  gap: theme.spacing[4],
}));

export const ProfileImageWrapper = styled.div(({ theme }) => ({
  width: theme.spacing[48],
  height: theme.spacing[48],
  flexShrink: 0,
  borderRadius: theme.spacing[4],
  backgroundColor: theme.colors.surface04,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
}));

export const ProfileImage = styled(Image)({
  objectFit: 'cover',
});

export const BannerText = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})({
  overflow: 'hidden',
  wordBreak: 'break-all',
  width: '100%',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1',
});

export const BannerSubText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  overflow: 'hidden',
  wordBreak: 'break-all',
  width: '100%',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1',
}));

export const ChevronIcon = styled(Image).attrs({
  src: '/images/icons/keyboard_arrow_right.svg',
  alt: 'Arrow right',
  width: 20,
  height: 20,
})({});
